var map = {
	"./activities/az.json": 42991,
	"./activities/bg.json": 54183,
	"./activities/de.json": 98815,
	"./activities/en-insure.json": 74260,
	"./activities/en.json": 71623,
	"./activities/es-insure.json": 47293,
	"./activities/es.json": 87728,
	"./activities/fi.json": 8153,
	"./activities/fr.json": 8596,
	"./activities/he.json": 14035,
	"./activities/it.json": 65101,
	"./activities/nl.json": 14218,
	"./activities/pl.json": 75696,
	"./activities/pt-insure.json": 6213,
	"./activities/pt.json": 22936,
	"./activities/ru.json": 72193,
	"./activities/sw.json": 27730,
	"./activities/th.json": 94136,
	"./activities/uk.json": 78056,
	"./activities/vi.json": 13449,
	"./az.json": 27833,
	"./bg.json": 43501,
	"./carbon/az.json": 32083,
	"./carbon/bg.json": 31459,
	"./carbon/de.json": 3091,
	"./carbon/en.json": 37243,
	"./carbon/es.json": 79372,
	"./carbon/fi.json": 49893,
	"./carbon/fr.json": 29504,
	"./carbon/he.json": 93900,
	"./carbon/it.json": 54553,
	"./carbon/nl.json": 67470,
	"./carbon/pt.json": 78500,
	"./carbon/ru.json": 32605,
	"./carbon/sw.json": 63390,
	"./carbon/th.json": 67380,
	"./carbon/uk.json": 6980,
	"./carbon/vi.json": 21109,
	"./certifications/az.json": 1725,
	"./certifications/bg.json": 74217,
	"./certifications/de.json": 26897,
	"./certifications/en.json": 43589,
	"./certifications/es.json": 17742,
	"./certifications/fi.json": 62527,
	"./certifications/fr.json": 83302,
	"./certifications/he.json": 84525,
	"./certifications/it.json": 89247,
	"./certifications/nl.json": 37976,
	"./certifications/pt.json": 6730,
	"./certifications/ru.json": 26223,
	"./certifications/sw.json": 69836,
	"./certifications/th.json": 64786,
	"./certifications/uk.json": 56390,
	"./certifications/vi.json": 64847,
	"./components/az.json": 67552,
	"./components/bg.json": 87352,
	"./components/de.json": 60836,
	"./components/en.json": 73824,
	"./components/es.json": 92791,
	"./components/fi.json": 77306,
	"./components/fr.json": 33667,
	"./components/he.json": 85640,
	"./components/it.json": 63806,
	"./components/nl.json": 65529,
	"./components/pl.json": 80475,
	"./components/pt.json": 35059,
	"./components/ru.json": 84330,
	"./components/sw.json": 51749,
	"./components/th.json": 8099,
	"./components/uk.json": 10047,
	"./components/vi.json": 8010,
	"./dashboard/action/add/az.json": 78717,
	"./dashboard/action/add/bg.json": 51209,
	"./dashboard/action/add/de.json": 46961,
	"./dashboard/action/add/en.json": 72389,
	"./dashboard/action/add/es.json": 9358,
	"./dashboard/action/add/fi.json": 86879,
	"./dashboard/action/add/fr.json": 36774,
	"./dashboard/action/add/he.json": 18989,
	"./dashboard/action/add/it.json": 3935,
	"./dashboard/action/add/nl.json": 98744,
	"./dashboard/action/add/pl.json": 82562,
	"./dashboard/action/add/pt.json": 98122,
	"./dashboard/action/add/ru.json": 44335,
	"./dashboard/action/add/sw.json": 73548,
	"./dashboard/action/add/th.json": 50514,
	"./dashboard/action/add/uk.json": 26214,
	"./dashboard/action/add/vi.json": 719,
	"./dashboard/action/cards/croparea/az.json": 41049,
	"./dashboard/action/cards/croparea/bg.json": 83437,
	"./dashboard/action/cards/croparea/de.json": 58429,
	"./dashboard/action/cards/croparea/en.json": 82769,
	"./dashboard/action/cards/croparea/es.json": 11314,
	"./dashboard/action/cards/croparea/fi.json": 36243,
	"./dashboard/action/cards/croparea/fr.json": 43946,
	"./dashboard/action/cards/croparea/he.json": 95809,
	"./dashboard/action/cards/croparea/it.json": 74355,
	"./dashboard/action/cards/croparea/nl.json": 66340,
	"./dashboard/action/cards/croparea/pl.json": 18022,
	"./dashboard/action/cards/croparea/pt.json": 45502,
	"./dashboard/action/cards/croparea/ru.json": 99667,
	"./dashboard/action/cards/croparea/sw.json": 29664,
	"./dashboard/action/cards/croparea/th.json": 86774,
	"./dashboard/action/cards/croparea/uk.json": 2730,
	"./dashboard/action/cards/croparea/vi.json": 45379,
	"./dashboard/action/cards/harvestedarea/az.json": 57507,
	"./dashboard/action/cards/harvestedarea/bg.json": 15731,
	"./dashboard/action/cards/harvestedarea/de.json": 79171,
	"./dashboard/action/cards/harvestedarea/en.json": 95659,
	"./dashboard/action/cards/harvestedarea/es.json": 73519,
	"./dashboard/action/cards/harvestedarea/fi.json": 29621,
	"./dashboard/action/cards/harvestedarea/fr.json": 41936,
	"./dashboard/action/cards/harvestedarea/he.json": 30351,
	"./dashboard/action/cards/harvestedarea/it.json": 36457,
	"./dashboard/action/cards/harvestedarea/nl.json": 72990,
	"./dashboard/action/cards/harvestedarea/pl.json": 5324,
	"./dashboard/action/cards/harvestedarea/pt.json": 80340,
	"./dashboard/action/cards/harvestedarea/ru.json": 18029,
	"./dashboard/action/cards/harvestedarea/sw.json": 41646,
	"./dashboard/action/cards/harvestedarea/th.json": 67908,
	"./dashboard/action/cards/harvestedarea/uk.json": 36180,
	"./dashboard/action/cards/harvestedarea/vi.json": 84709,
	"./dashboard/action/cards/hazardindex/az.json": 10020,
	"./dashboard/action/cards/hazardindex/bg.json": 70420,
	"./dashboard/action/cards/hazardindex/de.json": 93656,
	"./dashboard/action/cards/hazardindex/en.json": 46692,
	"./dashboard/action/cards/hazardindex/es.json": 21955,
	"./dashboard/action/cards/hazardindex/fi.json": 43910,
	"./dashboard/action/cards/hazardindex/fr.json": 74559,
	"./dashboard/action/cards/hazardindex/he.json": 79892,
	"./dashboard/action/cards/hazardindex/it.json": 72970,
	"./dashboard/action/cards/hazardindex/nl.json": 40205,
	"./dashboard/action/cards/hazardindex/pl.json": 65095,
	"./dashboard/action/cards/hazardindex/pt.json": 71839,
	"./dashboard/action/cards/hazardindex/ru.json": 8934,
	"./dashboard/action/cards/hazardindex/sw.json": 20689,
	"./dashboard/action/cards/hazardindex/th.json": 62015,
	"./dashboard/action/cards/hazardindex/uk.json": 93659,
	"./dashboard/action/cards/hazardindex/vi.json": 28214,
	"./dashboard/action/cards/phenostage/az.json": 52530,
	"./dashboard/action/cards/phenostage/bg.json": 83486,
	"./dashboard/action/cards/phenostage/de.json": 78162,
	"./dashboard/action/cards/phenostage/en.json": 25882,
	"./dashboard/action/cards/phenostage/es.json": 46377,
	"./dashboard/action/cards/phenostage/fi.json": 69436,
	"./dashboard/action/cards/phenostage/fr.json": 9201,
	"./dashboard/action/cards/phenostage/he.json": 72750,
	"./dashboard/action/cards/phenostage/it.json": 82620,
	"./dashboard/action/cards/phenostage/nl.json": 17819,
	"./dashboard/action/cards/phenostage/pl.json": 17817,
	"./dashboard/action/cards/phenostage/pt.json": 25729,
	"./dashboard/action/cards/phenostage/ru.json": 11372,
	"./dashboard/action/cards/phenostage/sw.json": 16675,
	"./dashboard/action/cards/phenostage/th.json": 34545,
	"./dashboard/action/cards/phenostage/uk.json": 7553,
	"./dashboard/action/cards/phenostage/vi.json": 40716,
	"./dashboard/action/cards/plantedarea/az.json": 31439,
	"./dashboard/action/cards/plantedarea/bg.json": 67751,
	"./dashboard/action/cards/plantedarea/de.json": 7039,
	"./dashboard/action/cards/plantedarea/en.json": 65959,
	"./dashboard/action/cards/plantedarea/es.json": 19248,
	"./dashboard/action/cards/plantedarea/fi.json": 70297,
	"./dashboard/action/cards/plantedarea/fr.json": 54292,
	"./dashboard/action/cards/plantedarea/he.json": 45331,
	"./dashboard/action/cards/plantedarea/it.json": 78989,
	"./dashboard/action/cards/plantedarea/nl.json": 82026,
	"./dashboard/action/cards/plantedarea/pl.json": 74256,
	"./dashboard/action/cards/plantedarea/pt.json": 67576,
	"./dashboard/action/cards/plantedarea/ru.json": 76865,
	"./dashboard/action/cards/plantedarea/sw.json": 89874,
	"./dashboard/action/cards/plantedarea/th.json": 73848,
	"./dashboard/action/cards/plantedarea/uk.json": 10248,
	"./dashboard/action/cards/plantedarea/vi.json": 31241,
	"./dashboard/action/options/az.json": 24738,
	"./dashboard/action/options/bg.json": 81582,
	"./dashboard/action/options/de.json": 56642,
	"./dashboard/action/options/en.json": 266,
	"./dashboard/action/options/es.json": 97209,
	"./dashboard/action/options/fi.json": 27628,
	"./dashboard/action/options/fr.json": 61921,
	"./dashboard/action/options/he.json": 89182,
	"./dashboard/action/options/it.json": 43308,
	"./dashboard/action/options/nl.json": 9227,
	"./dashboard/action/options/pl.json": 32073,
	"./dashboard/action/options/pt.json": 86001,
	"./dashboard/action/options/ru.json": 78460,
	"./dashboard/action/options/sw.json": 82771,
	"./dashboard/action/options/th.json": 90817,
	"./dashboard/action/options/uk.json": 40241,
	"./dashboard/action/options/vi.json": 92092,
	"./dashboard/cards/activities/az.json": 2468,
	"./dashboard/cards/activities/bg.json": 37684,
	"./dashboard/cards/activities/de.json": 38443,
	"./dashboard/cards/activities/en.json": 65444,
	"./dashboard/cards/activities/es.json": 94627,
	"./dashboard/cards/activities/fi.json": 78886,
	"./dashboard/cards/activities/fr.json": 66687,
	"./dashboard/cards/activities/he.json": 20436,
	"./dashboard/cards/activities/it.json": 87114,
	"./dashboard/cards/activities/nl.json": 81069,
	"./dashboard/cards/activities/pl.json": 71,
	"./dashboard/cards/activities/pt.json": 92927,
	"./dashboard/cards/activities/ru.json": 27558,
	"./dashboard/cards/activities/sw.json": 47153,
	"./dashboard/cards/activities/th.json": 43999,
	"./dashboard/cards/activities/uk.json": 14747,
	"./dashboard/cards/activities/vi.json": 49302,
	"./dashboard/cards/alerts/az.json": 17430,
	"./dashboard/cards/alerts/bg.json": 42810,
	"./dashboard/cards/alerts/de.json": 78518,
	"./dashboard/cards/alerts/en.json": 91022,
	"./dashboard/cards/alerts/es.json": 98181,
	"./dashboard/cards/alerts/fi.json": 37784,
	"./dashboard/cards/alerts/fr.json": 46061,
	"./dashboard/cards/alerts/he.json": 77738,
	"./dashboard/cards/alerts/it.json": 40792,
	"./dashboard/cards/alerts/nl.json": 62335,
	"./dashboard/cards/alerts/pl.json": 65141,
	"./dashboard/cards/alerts/pt.json": 68557,
	"./dashboard/cards/alerts/ru.json": 78696,
	"./dashboard/cards/alerts/sw.json": 66543,
	"./dashboard/cards/alerts/th.json": 23453,
	"./dashboard/cards/alerts/uk.json": 39917,
	"./dashboard/cards/alerts/vi.json": 78568,
	"./dashboard/cards/cas/az.json": 94802,
	"./dashboard/cards/cas/bg.json": 25758,
	"./dashboard/cards/cas/de.json": 20434,
	"./dashboard/cards/cas/en.json": 68154,
	"./dashboard/cards/cas/es.json": 88649,
	"./dashboard/cards/cas/fi.json": 11708,
	"./dashboard/cards/cas/fr.json": 51473,
	"./dashboard/cards/cas/he.json": 15022,
	"./dashboard/cards/cas/it.json": 24892,
	"./dashboard/cards/cas/nl.json": 60091,
	"./dashboard/cards/cas/pl.json": 60089,
	"./dashboard/cards/cas/pt.json": 68001,
	"./dashboard/cards/cas/ru.json": 53644,
	"./dashboard/cards/cas/sw.json": 58947,
	"./dashboard/cards/cas/th.json": 76817,
	"./dashboard/cards/cas/uk.json": 49825,
	"./dashboard/cards/cas/vi.json": 82988,
	"./dashboard/cards/financial/az.json": 37832,
	"./dashboard/cards/financial/bg.json": 2384,
	"./dashboard/cards/financial/de.json": 91292,
	"./dashboard/cards/financial/en.json": 54728,
	"./dashboard/cards/financial/es.json": 8239,
	"./dashboard/cards/financial/fi.json": 97218,
	"./dashboard/cards/financial/fr.json": 71323,
	"./dashboard/cards/financial/he.json": 27184,
	"./dashboard/cards/financial/it.json": 15750,
	"./dashboard/cards/financial/nl.json": 87153,
	"./dashboard/cards/financial/pl.json": 90499,
	"./dashboard/cards/financial/pt.json": 56779,
	"./dashboard/cards/financial/ru.json": 48546,
	"./dashboard/cards/financial/sw.json": 20733,
	"./dashboard/cards/financial/th.json": 64107,
	"./dashboard/cards/financial/uk.json": 94087,
	"./dashboard/cards/financial/vi.json": 75026,
	"./dashboard/cards/hai/az.json": 60019,
	"./dashboard/cards/hai/bg.json": 59395,
	"./dashboard/cards/hai/de.json": 31027,
	"./dashboard/cards/hai/en.json": 65179,
	"./dashboard/cards/hai/es.json": 7308,
	"./dashboard/cards/hai/fi.json": 94181,
	"./dashboard/cards/hai/fr.json": 57440,
	"./dashboard/cards/hai/he.json": 15807,
	"./dashboard/cards/hai/it.json": 82489,
	"./dashboard/cards/hai/nl.json": 95406,
	"./dashboard/cards/hai/pl.json": 31932,
	"./dashboard/cards/hai/pt.json": 6436,
	"./dashboard/cards/hai/ru.json": 60541,
	"./dashboard/cards/hai/sw.json": 91326,
	"./dashboard/cards/hai/th.json": 95316,
	"./dashboard/cards/hai/uk.json": 34916,
	"./dashboard/cards/hai/vi.json": 49045,
	"./dashboard/cards/hap/az.json": 11010,
	"./dashboard/cards/hap/bg.json": 19758,
	"./dashboard/cards/hap/de.json": 68098,
	"./dashboard/cards/hap/en.json": 426,
	"./dashboard/cards/hap/es.json": 25113,
	"./dashboard/cards/hap/fi.json": 14220,
	"./dashboard/cards/hap/fr.json": 48513,
	"./dashboard/cards/hap/he.json": 77566,
	"./dashboard/cards/hap/it.json": 24236,
	"./dashboard/cards/hap/nl.json": 38347,
	"./dashboard/cards/hap/pl.json": 99273,
	"./dashboard/cards/hap/pt.json": 38257,
	"./dashboard/cards/hap/ru.json": 73564,
	"./dashboard/cards/hap/sw.json": 20947,
	"./dashboard/cards/hap/th.json": 44897,
	"./dashboard/cards/hap/uk.json": 21169,
	"./dashboard/cards/hap/vi.json": 21436,
	"./dashboard/cards/inspections/az.json": 52396,
	"./dashboard/cards/inspections/bg.json": 86732,
	"./dashboard/cards/inspections/de.json": 40880,
	"./dashboard/cards/inspections/en.json": 31596,
	"./dashboard/cards/inspections/es.json": 10651,
	"./dashboard/cards/inspections/fi.json": 90670,
	"./dashboard/cards/inspections/fr.json": 57943,
	"./dashboard/cards/inspections/he.json": 80124,
	"./dashboard/cards/inspections/it.json": 42898,
	"./dashboard/cards/inspections/nl.json": 10405,
	"./dashboard/cards/inspections/pl.json": 86319,
	"./dashboard/cards/inspections/pt.json": 61271,
	"./dashboard/cards/inspections/ru.json": 28958,
	"./dashboard/cards/inspections/sw.json": 64297,
	"./dashboard/cards/inspections/th.json": 17063,
	"./dashboard/cards/inspections/uk.json": 73251,
	"./dashboard/cards/inspections/vi.json": 88382,
	"./dashboard/cards/links/az.json": 20438,
	"./dashboard/cards/links/bg.json": 29466,
	"./dashboard/cards/links/de.json": 81526,
	"./dashboard/cards/links/en.json": 77678,
	"./dashboard/cards/links/es.json": 1189,
	"./dashboard/cards/links/fi.json": 18411,
	"./dashboard/cards/links/fr.json": 49069,
	"./dashboard/cards/links/he.json": 80746,
	"./dashboard/cards/links/it.json": 43800,
	"./dashboard/cards/links/nl.json": 65343,
	"./dashboard/cards/links/pl.json": 68149,
	"./dashboard/cards/links/pt.json": 55213,
	"./dashboard/cards/links/ru.json": 65352,
	"./dashboard/cards/links/sw.json": 69551,
	"./dashboard/cards/links/th.json": 10109,
	"./dashboard/cards/links/uk.json": 26573,
	"./dashboard/cards/links/vi.json": 65224,
	"./dashboard/cards/map/az.json": 28843,
	"./dashboard/cards/map/bg.json": 9835,
	"./dashboard/cards/map/de.json": 84731,
	"./dashboard/cards/map/en.json": 65299,
	"./dashboard/cards/map/es.json": 14260,
	"./dashboard/cards/map/fi.json": 6653,
	"./dashboard/cards/map/fr.json": 17448,
	"./dashboard/cards/map/he.json": 28439,
	"./dashboard/cards/map/it.json": 70449,
	"./dashboard/cards/map/nl.json": 58198,
	"./dashboard/cards/map/pl.json": 20724,
	"./dashboard/cards/map/pt.json": 70700,
	"./dashboard/cards/map/ru.json": 8293,
	"./dashboard/cards/map/sw.json": 48678,
	"./dashboard/cards/map/th.json": 87724,
	"./dashboard/cards/map/uk.json": 19228,
	"./dashboard/cards/map/vi.json": 18061,
	"./dashboard/cards/ndvi/az.json": 23254,
	"./dashboard/cards/ndvi/bg.json": 8730,
	"./dashboard/cards/ndvi/de.json": 29110,
	"./dashboard/cards/ndvi/en.json": 22926,
	"./dashboard/cards/ndvi/es.json": 32421,
	"./dashboard/cards/ndvi/fi.json": 91800,
	"./dashboard/cards/ndvi/fr.json": 77,
	"./dashboard/cards/ndvi/he.json": 5034,
	"./dashboard/cards/ndvi/it.json": 54968,
	"./dashboard/cards/ndvi/nl.json": 67615,
	"./dashboard/cards/ndvi/pl.json": 86773,
	"./dashboard/cards/ndvi/pt.json": 97133,
	"./dashboard/cards/ndvi/ru.json": 72616,
	"./dashboard/cards/ndvi/sw.json": 20559,
	"./dashboard/cards/ndvi/th.json": 34397,
	"./dashboard/cards/ndvi/uk.json": 14573,
	"./dashboard/cards/ndvi/vi.json": 46984,
	"./dashboard/cards/notes/az.json": 94722,
	"./dashboard/cards/notes/bg.json": 19822,
	"./dashboard/cards/notes/de.json": 68162,
	"./dashboard/cards/notes/en.json": 490,
	"./dashboard/cards/notes/es.json": 8825,
	"./dashboard/cards/notes/fi.json": 14284,
	"./dashboard/cards/notes/fr.json": 48577,
	"./dashboard/cards/notes/he.json": 61278,
	"./dashboard/cards/notes/it.json": 7948,
	"./dashboard/cards/notes/nl.json": 38411,
	"./dashboard/cards/notes/pl.json": 99337,
	"./dashboard/cards/notes/pt.json": 38321,
	"./dashboard/cards/notes/ru.json": 73628,
	"./dashboard/cards/notes/sw.json": 21011,
	"./dashboard/cards/notes/th.json": 28609,
	"./dashboard/cards/notes/uk.json": 21233,
	"./dashboard/cards/notes/vi.json": 5148,
	"./dashboard/cards/pap/az.json": 43834,
	"./dashboard/cards/pap/bg.json": 47158,
	"./dashboard/cards/pap/de.json": 53130,
	"./dashboard/cards/pap/en.json": 34722,
	"./dashboard/cards/pap/es.json": 20065,
	"./dashboard/cards/pap/fi.json": 41604,
	"./dashboard/cards/pap/fr.json": 17513,
	"./dashboard/cards/pap/he.json": 3510,
	"./dashboard/cards/pap/it.json": 28964,
	"./dashboard/cards/pap/nl.json": 33299,
	"./dashboard/cards/pap/pl.json": 29441,
	"./dashboard/cards/pap/pt.json": 12793,
	"./dashboard/cards/pap/ru.json": 96708,
	"./dashboard/cards/pap/sw.json": 12155,
	"./dashboard/cards/pap/th.json": 99065,
	"./dashboard/cards/pap/uk.json": 34505,
	"./dashboard/cards/pap/vi.json": 85588,
	"./dashboard/cards/pictures/az.json": 64730,
	"./dashboard/cards/pictures/bg.json": 22486,
	"./dashboard/cards/pictures/de.json": 330,
	"./dashboard/cards/pictures/en.json": 24450,
	"./dashboard/cards/pictures/es.json": 43969,
	"./dashboard/cards/pictures/fi.json": 5028,
	"./dashboard/cards/pictures/fr.json": 19561,
	"./dashboard/cards/pictures/he.json": 1110,
	"./dashboard/cards/pictures/it.json": 12164,
	"./dashboard/cards/pictures/nl.json": 147,
	"./dashboard/cards/pictures/pl.json": 62113,
	"./dashboard/cards/pictures/pt.json": 29241,
	"./dashboard/cards/pictures/ru.json": 43780,
	"./dashboard/cards/pictures/sw.json": 62779,
	"./dashboard/cards/pictures/th.json": 39193,
	"./dashboard/cards/pictures/uk.json": 36553,
	"./dashboard/cards/pictures/vi.json": 49012,
	"./dashboard/cards/psp/az.json": 63828,
	"./dashboard/cards/psp/bg.json": 22916,
	"./dashboard/cards/psp/de.json": 57192,
	"./dashboard/cards/psp/en.json": 77460,
	"./dashboard/cards/psp/es.json": 44723,
	"./dashboard/cards/psp/fi.json": 24694,
	"./dashboard/cards/psp/fr.json": 98223,
	"./dashboard/cards/psp/he.json": 16036,
	"./dashboard/cards/psp/it.json": 14522,
	"./dashboard/cards/psp/nl.json": 91997,
	"./dashboard/cards/psp/pl.json": 95735,
	"./dashboard/cards/psp/pt.json": 78255,
	"./dashboard/cards/psp/ru.json": 79798,
	"./dashboard/cards/psp/sw.json": 8801,
	"./dashboard/cards/psp/th.json": 61359,
	"./dashboard/cards/psp/uk.json": 19915,
	"./dashboard/cards/psp/vi.json": 40390,
	"./dashboard/cards/titles/az.json": 47042,
	"./dashboard/cards/titles/bg.json": 55790,
	"./dashboard/cards/titles/de.json": 20482,
	"./dashboard/cards/titles/en.json": 36458,
	"./dashboard/cards/titles/es.json": 61145,
	"./dashboard/cards/titles/fi.json": 66604,
	"./dashboard/cards/titles/fr.json": 897,
	"./dashboard/cards/titles/he.json": 13598,
	"./dashboard/cards/titles/it.json": 60268,
	"./dashboard/cards/titles/nl.json": 90731,
	"./dashboard/cards/titles/pl.json": 51657,
	"./dashboard/cards/titles/pt.json": 90641,
	"./dashboard/cards/titles/ru.json": 25948,
	"./dashboard/cards/titles/sw.json": 73331,
	"./dashboard/cards/titles/th.json": 80929,
	"./dashboard/cards/titles/uk.json": 73553,
	"./dashboard/cards/titles/vi.json": 57468,
	"./dashboard/cards/topdiseases/az.json": 42261,
	"./dashboard/cards/topdiseases/bg.json": 92465,
	"./dashboard/cards/topdiseases/de.json": 83161,
	"./dashboard/cards/topdiseases/en.json": 56221,
	"./dashboard/cards/topdiseases/es.json": 11542,
	"./dashboard/cards/topdiseases/fi.json": 81047,
	"./dashboard/cards/topdiseases/fr.json": 28494,
	"./dashboard/cards/topdiseases/he.json": 7269,
	"./dashboard/cards/topdiseases/it.json": 22935,
	"./dashboard/cards/topdiseases/nl.json": 98080,
	"./dashboard/cards/topdiseases/pl.json": 48570,
	"./dashboard/cards/topdiseases/pt.json": 14130,
	"./dashboard/cards/topdiseases/ru.json": 62967,
	"./dashboard/cards/topdiseases/sw.json": 70292,
	"./dashboard/cards/topdiseases/th.json": 44298,
	"./dashboard/cards/topdiseases/uk.json": 65182,
	"./dashboard/cards/topdiseases/vi.json": 34439,
	"./dashboard/cards/toppests/az.json": 93551,
	"./dashboard/cards/toppests/bg.json": 10759,
	"./dashboard/cards/toppests/de.json": 80127,
	"./dashboard/cards/toppests/en.json": 1351,
	"./dashboard/cards/toppests/es.json": 24016,
	"./dashboard/cards/toppests/fi.json": 75065,
	"./dashboard/cards/toppests/fr.json": 70452,
	"./dashboard/cards/toppests/he.json": 61619,
	"./dashboard/cards/toppests/it.json": 11501,
	"./dashboard/cards/toppests/nl.json": 17546,
	"./dashboard/cards/toppests/pl.json": 5744,
	"./dashboard/cards/toppests/pt.json": 52984,
	"./dashboard/cards/toppests/ru.json": 53505,
	"./dashboard/cards/toppests/sw.json": 9042,
	"./dashboard/cards/toppests/th.json": 50488,
	"./dashboard/cards/toppests/uk.json": 38856,
	"./dashboard/cards/toppests/vi.json": 74249,
	"./dashboard/cards/topweeds/az.json": 17158,
	"./dashboard/cards/topweeds/bg.json": 26922,
	"./dashboard/cards/topweeds/de.json": 80326,
	"./dashboard/cards/topweeds/en.json": 42142,
	"./dashboard/cards/topweeds/es.json": 39893,
	"./dashboard/cards/topweeds/fi.json": 48328,
	"./dashboard/cards/topweeds/fr.json": 51933,
	"./dashboard/cards/topweeds/he.json": 3098,
	"./dashboard/cards/topweeds/it.json": 13992,
	"./dashboard/cards/topweeds/nl.json": 49359,
	"./dashboard/cards/topweeds/pl.json": 70021,
	"./dashboard/cards/topweeds/pt.json": 38109,
	"./dashboard/cards/topweeds/ru.json": 74968,
	"./dashboard/cards/topweeds/sw.json": 21535,
	"./dashboard/cards/topweeds/th.json": 86989,
	"./dashboard/cards/topweeds/uk.json": 7517,
	"./dashboard/cards/topweeds/vi.json": 7544,
	"./dashboard/cards/upvs/az.json": 74513,
	"./dashboard/cards/upvs/bg.json": 1845,
	"./dashboard/cards/upvs/de.json": 24485,
	"./dashboard/cards/upvs/en.json": 3305,
	"./dashboard/cards/upvs/es.json": 30170,
	"./dashboard/cards/upvs/fi.json": 2251,
	"./dashboard/cards/upvs/fr.json": 45586,
	"./dashboard/cards/upvs/he.json": 69625,
	"./dashboard/cards/upvs/it.json": 28715,
	"./dashboard/cards/upvs/nl.json": 70668,
	"./dashboard/cards/upvs/pl.json": 54686,
	"./dashboard/cards/upvs/pt.json": 92902,
	"./dashboard/cards/upvs/ru.json": 77211,
	"./dashboard/cards/upvs/sw.json": 37192,
	"./dashboard/cards/upvs/th.json": 86977,
	"./dashboard/cards/upvs/uk.json": 38882,
	"./dashboard/cards/upvs/vi.json": 2843,
	"./dashboard/cards/weather/az.json": 84965,
	"./dashboard/cards/weather/bg.json": 93185,
	"./dashboard/cards/weather/de.json": 88841,
	"./dashboard/cards/weather/en.json": 94733,
	"./dashboard/cards/weather/es.json": 99718,
	"./dashboard/cards/weather/fi.json": 20071,
	"./dashboard/cards/weather/fr.json": 29662,
	"./dashboard/cards/weather/he.json": 12533,
	"./dashboard/cards/weather/it.json": 84583,
	"./dashboard/cards/weather/nl.json": 69136,
	"./dashboard/cards/weather/pl.json": 7658,
	"./dashboard/cards/weather/pt.json": 97442,
	"./dashboard/cards/weather/ru.json": 97799,
	"./dashboard/cards/weather/sw.json": 82820,
	"./dashboard/cards/weather/th.json": 33946,
	"./dashboard/cards/weather/uk.json": 33742,
	"./dashboard/cards/weather/vi.json": 22551,
	"./dashboard/dashboard/az.json": 53681,
	"./dashboard/dashboard/bg.json": 37941,
	"./dashboard/dashboard/de.json": 13605,
	"./dashboard/dashboard/en.json": 44233,
	"./dashboard/dashboard/es.json": 4890,
	"./dashboard/dashboard/fi.json": 60728,
	"./dashboard/dashboard/fr.json": 84690,
	"./dashboard/dashboard/he.json": 32569,
	"./dashboard/dashboard/it.json": 3435,
	"./dashboard/dashboard/nl.json": 69068,
	"./dashboard/dashboard/pl.json": 90782,
	"./dashboard/dashboard/pt.json": 26662,
	"./dashboard/dashboard/ru.json": 80443,
	"./dashboard/dashboard/sw.json": 6248,
	"./dashboard/dashboard/th.json": 14926,
	"./dashboard/dashboard/uk.json": 44450,
	"./dashboard/dashboard/vi.json": 59995,
	"./dashboard/toolbar/az.json": 27160,
	"./dashboard/toolbar/bg.json": 24832,
	"./dashboard/toolbar/de.json": 60844,
	"./dashboard/toolbar/en.json": 24664,
	"./dashboard/toolbar/es.json": 91743,
	"./dashboard/toolbar/fi.json": 42642,
	"./dashboard/toolbar/fr.json": 96299,
	"./dashboard/toolbar/he.json": 94784,
	"./dashboard/toolbar/it.json": 502,
	"./dashboard/toolbar/nl.json": 27009,
	"./dashboard/toolbar/pl.json": 98803,
	"./dashboard/toolbar/pt.json": 86619,
	"./dashboard/toolbar/ru.json": 3890,
	"./dashboard/toolbar/sw.json": 11661,
	"./dashboard/toolbar/th.json": 27195,
	"./dashboard/toolbar/uk.json": 57591,
	"./dashboard/toolbar/vi.json": 2146,
	"./de.json": 52669,
	"./en-insure.json": 53174,
	"./en.json": 88913,
	"./es-insure.json": 26591,
	"./es.json": 23122,
	"./eudr/az.json": 35948,
	"./eudr/bg.json": 70284,
	"./eudr/de.json": 56816,
	"./eudr/en.json": 65292,
	"./eudr/es.json": 23163,
	"./eudr/fi.json": 846,
	"./eudr/fr.json": 64791,
	"./eudr/he.json": 20924,
	"./eudr/it.json": 32114,
	"./eudr/nl.json": 22917,
	"./eudr/pt.json": 40919,
	"./eudr/ru.json": 10718,
	"./eudr/sw.json": 10985,
	"./eudr/th.json": 43463,
	"./eudr/uk.json": 58243,
	"./eudr/vi.json": 51422,
	"./farms/ar.json": 2511,
	"./farms/az.json": 73159,
	"./farms/bg.json": 68175,
	"./farms/de.json": 67975,
	"./farms/en.json": 27423,
	"./farms/es.json": 14264,
	"./farms/fi.json": 21841,
	"./farms/fr.json": 31900,
	"./farms/he.json": 72171,
	"./farms/it.json": 78597,
	"./farms/nl.json": 54162,
	"./farms/pl.json": 51432,
	"./farms/pt.json": 52032,
	"./farms/ru.json": 19241,
	"./farms/sw.json": 64410,
	"./farms/th.json": 85264,
	"./farms/uk.json": 15200,
	"./farms/vi.json": 81761,
	"./farms/zh.json": 89138,
	"./fi.json": 21427,
	"./filter/az.json": 8638,
	"./filter/bg.json": 57586,
	"./filter/de.json": 60654,
	"./filter/en-insure.json": 77963,
	"./filter/en.json": 44246,
	"./filter/es-insure.json": 74666,
	"./filter/es.json": 88925,
	"./filter/fi.json": 43552,
	"./filter/fr.json": 18757,
	"./filter/he.json": 14482,
	"./filter/it.json": 1664,
	"./filter/nl.json": 75095,
	"./filter/pl.json": 75261,
	"./filter/pt-insure.json": 35218,
	"./filter/pt.json": 28229,
	"./filter/ru.json": 88448,
	"./filter/sw.json": 90055,
	"./filter/th.json": 71845,
	"./filter/uk.json": 49397,
	"./filter/vi.json": 21680,
	"./forms/az.json": 56477,
	"./forms/bg.json": 12617,
	"./forms/de.json": 8369,
	"./forms/en.json": 33797,
	"./forms/es.json": 87118,
	"./forms/fi.json": 48287,
	"./forms/fr.json": 14534,
	"./forms/he.json": 80397,
	"./forms/it.json": 81695,
	"./forms/nl.json": 60152,
	"./forms/pl.json": 60322,
	"./forms/pt.json": 75882,
	"./forms/ru.json": 22095,
	"./forms/sw.json": 51308,
	"./forms/th.json": 11922,
	"./forms/uk.json": 3974,
	"./forms/vi.json": 78479,
	"./fr.json": 80349,
	"./general/az.json": 76972,
	"./general/bg.json": 11308,
	"./general/de.json": 16144,
	"./general/en.json": 43852,
	"./general/es.json": 40347,
	"./general/fi.json": 72494,
	"./general/fr.json": 25047,
	"./general/he.json": 18876,
	"./general/it.json": 73138,
	"./general/nl.json": 71269,
	"./general/pl.json": 66415,
	"./general/pt.json": 247,
	"./general/ru.json": 46750,
	"./general/sw.json": 75145,
	"./general/th.json": 72039,
	"./general/uk.json": 6595,
	"./general/vi.json": 18622,
	"./he.json": 73857,
	"./header/az.json": 98715,
	"./header/bg.json": 64379,
	"./header/de.json": 90827,
	"./header/en.json": 55011,
	"./header/es.json": 79748,
	"./header/fi.json": 7405,
	"./header/fr.json": 15480,
	"./header/he.json": 31655,
	"./header/it.json": 61537,
	"./header/nl.json": 2342,
	"./header/pl.json": 23940,
	"./header/pt.json": 2460,
	"./header/ru.json": 49653,
	"./header/sw.json": 51510,
	"./header/th.json": 39772,
	"./header/uk.json": 28588,
	"./header/vi.json": 13629,
	"./hierarchies/az.json": 697,
	"./hierarchies/bg.json": 59437,
	"./hierarchies/de.json": 18077,
	"./hierarchies/en.json": 42417,
	"./hierarchies/es.json": 70962,
	"./hierarchies/fi.json": 95891,
	"./hierarchies/fr.json": 19946,
	"./hierarchies/he.json": 55457,
	"./hierarchies/it.json": 34003,
	"./hierarchies/nl.json": 42340,
	"./hierarchies/pt.json": 5150,
	"./hierarchies/ru.json": 59315,
	"./hierarchies/sw.json": 5664,
	"./hierarchies/th.json": 46422,
	"./hierarchies/uk.json": 78730,
	"./hierarchies/vi.json": 5027,
	"./import/en.json": 5311,
	"./integration/az.json": 27782,
	"./integration/bg.json": 53898,
	"./integration/de.json": 90950,
	"./integration/en-insure.json": 75091,
	"./integration/en.json": 69118,
	"./integration/es-insure.json": 97282,
	"./integration/es.json": 66869,
	"./integration/fi.json": 58952,
	"./integration/fr.json": 62557,
	"./integration/he.json": 30074,
	"./integration/it.json": 24616,
	"./integration/nl.json": 76335,
	"./integration/pl.json": 80645,
	"./integration/pt-insure.json": 69610,
	"./integration/pt.json": 48733,
	"./integration/ru.json": 85592,
	"./integration/sw.json": 32159,
	"./integration/th.json": 97613,
	"./integration/uk.json": 34493,
	"./integration/vi.json": 34520,
	"./it.json": 59539,
	"./login/az.json": 22399,
	"./login/bg.json": 63255,
	"./login/de.json": 39023,
	"./login/en.json": 77143,
	"./login/es.json": 59776,
	"./login/fi.json": 53321,
	"./login/fr.json": 57860,
	"./login/he.json": 40547,
	"./login/it.json": 861,
	"./login/nl.json": 92762,
	"./login/pt.json": 76744,
	"./login/ru.json": 43633,
	"./login/sw.json": 23810,
	"./login/th.json": 51112,
	"./login/uk.json": 65272,
	"./login/vi.json": 76025,
	"./map/az.json": 10318,
	"./map/bg.json": 90786,
	"./map/de.json": 75230,
	"./map/en-insure.json": 95931,
	"./map/en.json": 13990,
	"./map/es-insure.json": 21882,
	"./map/es.json": 53133,
	"./map/fi.json": 99728,
	"./map/fr.json": 71061,
	"./map/he.json": 61538,
	"./map/it.json": 50224,
	"./map/nl.json": 65671,
	"./map/pl.json": 67629,
	"./map/pt-insure.json": 23650,
	"./map/pt.json": 57269,
	"./map/ru.json": 51056,
	"./map/sw.json": 43063,
	"./map/th.json": 77941,
	"./map/uk.json": 92197,
	"./map/vi.json": 45664,
	"./mini_plot/az.json": 94033,
	"./mini_plot/bg.json": 21365,
	"./mini_plot/de.json": 27653,
	"./mini_plot/en.json": 6473,
	"./mini_plot/es.json": 49690,
	"./mini_plot/fi.json": 21771,
	"./mini_plot/fr.json": 65106,
	"./mini_plot/he.json": 89145,
	"./mini_plot/it.json": 31883,
	"./mini_plot/nl.json": 90188,
	"./mini_plot/pt.json": 12422,
	"./mini_plot/ru.json": 96731,
	"./mini_plot/sw.json": 56712,
	"./mini_plot/th.json": 12526,
	"./mini_plot/uk.json": 42050,
	"./mini_plot/vi.json": 6011,
	"./nl.json": 29732,
	"./notifications/az.json": 41408,
	"./notifications/bg.json": 68792,
	"./notifications/de.json": 11524,
	"./notifications/en.json": 38912,
	"./notifications/es.json": 56279,
	"./notifications/fi.json": 44346,
	"./notifications/fr.json": 80931,
	"./notifications/he.json": 2696,
	"./notifications/it.json": 10942,
	"./notifications/nl.json": 43961,
	"./notifications/pl.json": 43963,
	"./notifications/pt.json": 39795,
	"./notifications/ru.json": 91946,
	"./notifications/sw.json": 76133,
	"./notifications/th.json": 1859,
	"./notifications/uk.json": 65183,
	"./notifications/vi.json": 55690,
	"./notifications_configs/az.json": 6136,
	"./notifications_configs/bg.json": 99360,
	"./notifications_configs/de.json": 71660,
	"./notifications_configs/en.json": 38712,
	"./notifications_configs/es.json": 13247,
	"./notifications_configs/fi.json": 57234,
	"./notifications_configs/fr.json": 13899,
	"./notifications_configs/he.json": 43008,
	"./notifications_configs/it.json": 50966,
	"./notifications_configs/nl.json": 70894,
	"./notifications_configs/pl.json": 52371,
	"./notifications_configs/pt.json": 83163,
	"./notifications_configs/ru.json": 2130,
	"./notifications_configs/sw.json": 40109,
	"./notifications_configs/th.json": 61307,
	"./notifications_configs/uk.json": 25879,
	"./notifications_configs/vi.json": 79010,
	"./pl.json": 97638,
	"./policy/az.json": 35817,
	"./policy/bg.json": 43674,
	"./policy/de.json": 64054,
	"./policy/en-insure.json": 11235,
	"./policy/en.json": 57870,
	"./policy/es-insure.json": 54098,
	"./policy/es.json": 83717,
	"./policy/fi.json": 26744,
	"./policy/fr.json": 35021,
	"./policy/he.json": 39978,
	"./policy/it.json": 89912,
	"./policy/nl.json": 2559,
	"./policy/pt-insure.json": 29178,
	"./policy/pt.json": 32077,
	"./policy/ru.json": 23912,
	"./policy/sw.json": 55503,
	"./policy/th.json": 69341,
	"./policy/uk.json": 49517,
	"./policy/vi.json": 98280,
	"./pt-insure.json": 11443,
	"./pt.json": 61758,
	"./ru.json": 6003,
	"./sat/az.json": 89024,
	"./sat/bg.json": 56,
	"./sat/de.json": 42788,
	"./sat/en.json": 86528,
	"./sat/es.json": 87543,
	"./sat/fi.json": 75610,
	"./sat/fr.json": 12195,
	"./sat/he.json": 50312,
	"./sat/it.json": 58558,
	"./sat/nl.json": 75225,
	"./sat/pl.json": 75227,
	"./sat/pt.json": 87411,
	"./sat/ru.json": 39562,
	"./sat/sw.json": 23749,
	"./sat/th.json": 33123,
	"./sat/uk.json": 96447,
	"./sat/vi.json": 3306,
	"./season_planner/az.json": 45110,
	"./season_planner/bg.json": 70490,
	"./season_planner/de.json": 6198,
	"./season_planner/en.json": 2350,
	"./season_planner/es.json": 25861,
	"./season_planner/fi.json": 65464,
	"./season_planner/fr.json": 73741,
	"./season_planner/he.json": 5418,
	"./season_planner/it.json": 68472,
	"./season_planner/nl.json": 90015,
	"./season_planner/pt.json": 96237,
	"./season_planner/ru.json": 90024,
	"./season_planner/sw.json": 94223,
	"./season_planner/th.json": 51133,
	"./season_planner/uk.json": 67597,
	"./season_planner/vi.json": 83867,
	"./select/az.json": 31676,
	"./select/bg.json": 87580,
	"./select/de.json": 56384,
	"./select/en.json": 63196,
	"./select/es.json": 45291,
	"./select/fi.json": 98366,
	"./select/fr.json": 92327,
	"./select/he.json": 70476,
	"./select/it.json": 65154,
	"./select/nl.json": 42197,
	"./select/pt.json": 75719,
	"./select/ru.json": 22158,
	"./select/sw.json": 18809,
	"./select/th.json": 99799,
	"./select/uk.json": 58867,
	"./select/vi.json": 654,
	"./sw.json": 45920,
	"./tables/az.json": 65735,
	"./tables/bg.json": 85871,
	"./tables/de.json": 85351,
	"./tables/en.json": 41695,
	"./tables/es.json": 74616,
	"./tables/fi.json": 60177,
	"./tables/fr.json": 74460,
	"./tables/he.json": 37227,
	"./tables/it.json": 96293,
	"./tables/nl.json": 98162,
	"./tables/pt.json": 90368,
	"./tables/ru.json": 67689,
	"./tables/sw.json": 49722,
	"./tables/th.json": 2960,
	"./tables/uk.json": 27232,
	"./tables/vi.json": 50721,
	"./tables_config/az.json": 81800,
	"./tables_config/bg.json": 39408,
	"./tables_config/de.json": 66012,
	"./tables_config/en.json": 56168,
	"./tables_config/es.json": 75887,
	"./tables_config/fi.json": 45218,
	"./tables_config/fr.json": 35547,
	"./tables_config/he.json": 63280,
	"./tables_config/it.json": 40326,
	"./tables_config/nl.json": 24177,
	"./tables_config/pt.json": 17099,
	"./tables_config/ru.json": 80194,
	"./tables_config/sw.json": 19133,
	"./tables_config/th.json": 85803,
	"./tables_config/uk.json": 35015,
	"./tables_config/vi.json": 23442,
	"./th.json": 7734,
	"./time/az.json": 91091,
	"./time/bg.json": 38691,
	"./time/de.json": 42451,
	"./time/en.json": 12283,
	"./time/es.json": 90828,
	"./time/fi.json": 8709,
	"./time/fr.json": 33504,
	"./time/he.json": 77311,
	"./time/it.json": 23481,
	"./time/nl.json": 5326,
	"./time/pl.json": 67036,
	"./time/pt.json": 39652,
	"./time/ru.json": 13309,
	"./time/sw.json": 67390,
	"./time/th.json": 48308,
	"./time/uk.json": 96740,
	"./time/vi.json": 82581,
	"./uk.json": 51818,
	"./vi.json": 62691
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16152;